import React from 'react';

import Dropdown from 'components/Toolbar/Shared/Dropdown';
import { intlGet } from 'utils/intlGet';
import { AltTagDropdownProps } from './models';
import styles from './styles.module.scss';

const AltTagDropdown: React.FunctionComponent<AltTagDropdownProps> = (props) => {
  const {
    altTag,
    toggleAltTag,
    dataTestId = 'altTag',
  } = props;
  const altTagRef = React.useRef(altTag);

  React.useEffect(
    () => { altTagRef.current = altTag; },
    [altTag],
  );

  React.useEffect(
    () => () => {
      const { current: currentAltTag } = altTagRef;

      toggleAltTag(currentAltTag);
    },
    [],
  );

  const onAltTagChange = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
    toggleAltTag(event.target.value);
  };

  return (
    <Dropdown className={styles.AltTagDropdown} stopClickPropagation={true} dataTestId={`${dataTestId}-dropdown`}>
      <div className={styles.title} data-testid={`${dataTestId}-title`}>
        {intlGet('EditorToolbar.AltTag', 'Title')}
      </div>
      <div className={styles.container} data-testid={`${dataTestId}-container`}>
        <textarea
          maxLength={255}
          autoFocus={true}
          className={styles.textarea}
          onChange={onAltTagChange}
          placeholder={intlGet('EditorToolbar.AltTag', 'Placeholder')}
          value={altTag}
          data-testid={`${dataTestId}-textarea`}
        />
      </div>
    </Dropdown>
  );
};

export default AltTagDropdown;
